import React from "react";

//components
import Main from "./components/Main";

//style
import { Container } from 'react-bootstrap';




export default function App() {
  return (  
     <Container className="bg-light">
       <Main/>
     </Container>  
  );
}
